export default "__VITE_ASSET__6a0bca73__"